import React from "react";

const ButtonReset = ({ reset }) => {
  return (
    <button className="reset" onClick={reset}>
      ล้างโพย
    </button>
  );
};

export default ButtonReset;
